module.exports = __webpack_public_path__ + "img/potrait-user-cloud.ca64a7e2.png";